var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row my-3"},[_c('h2',{staticClass:"col-sm-12"},[_vm._v("Resolución")])])])
}]

export { render, staticRenderFns }